import { type Theme, createTheme } from '@mui/material/styles';
import { themeOverrides } from './themeOverrides';

export const theme: Theme = createTheme(themeOverrides);
